import bus from '@/event-bus/EventBus'

export default {
    methods: {
        onPrintChartHandler (widgetID) {
            if (this.data.WidgetID.toString() !== widgetID.toString()) {
                return
            }
            this.tryPrintChart()
        },
        onDownloadChartHandler ({ type, WidgetID }) {
            if (this.data.WidgetID.toString() !== WidgetID.toString()) {
                return
            }
            this.tryDownloadChart(type)
        },
        triggerPrintEvent() {
            bus.$on('print-chart', this.onPrintChartHandler)
        },
        triggerDownloadEvent() {
            bus.$on('download-chart', this.onDownloadChartHandler)
        },
    },
    mounted() {
        this.triggerPrintEvent()
        this.triggerDownloadEvent()
    },
    beforeDestroy() {
        bus.$off('print-chart', this.onPrintChartHandler)
        bus.$off('download-chart', this.onDownloadChartHandler)
    }
}
